export interface BrowserInformationStruct {
    msie: boolean;
    edge: boolean;
    chrome: boolean;
    safari: boolean;
    mozilla: boolean;
    webkit: boolean;
    version: string;

    isWindows: boolean;
    isMacintosh: boolean;
    iOS: boolean;
}

export class BrowserInformation {
    private static _instance: BrowserInformation;
    private _browserInformation: BrowserInformationStruct | undefined;

    public static getInstance(): BrowserInformation {
        if (!BrowserInformation._instance) {
            BrowserInformation._instance = new BrowserInformation();
            this._instance._initialize();
        }
        return BrowserInformation._instance;
    }

    public getBrowserInformation(): BrowserInformationStruct {
        return this._browserInformation;
    }

    private _initialize(): void {
        if (!this._browserInformation) {
            this._browserInformation = {} as any;
            if (!this._browserInformation) return; // hint typescript compiler that _browserInformation is now assigned;

            this._browserInformation.isWindows = navigator.platform.indexOf("Win") > -1;
            this._browserInformation.isMacintosh = navigator.userAgent.indexOf("Mac OS X") > -1;
            const iOS = /iphone|ipod|ipad/i.exec(navigator.userAgent);
            if (iOS) {
                this._browserInformation.iOS = true;
            }

            const edge = /edge\/([\d+.]+)/i.exec(navigator.userAgent);
            if (edge) {
                this._browserInformation.edge = true;
                this._browserInformation.version = edge[1];
                return;
            }

            const msie = /msie ([\d+.]+)/i.exec(navigator.userAgent);
            if (msie) {
                this._browserInformation.msie = true;
                this._browserInformation.version = msie[1];
                return;
            }

            const chrome = /chrome\/([\d.]+)/i.exec(navigator.userAgent);
            if (chrome) {
                this._browserInformation.chrome = true;
                this._browserInformation.webkit = true;
                this._browserInformation.version = chrome[1];
                return;
            }

            const safari = /safari\/([\d.]+)/i.exec(navigator.userAgent);
            if (safari) {
                this._browserInformation.safari = true;
                this._browserInformation.webkit = true;
                this._browserInformation.version = safari[1];
                return;
            }

            const mozilla = /mozilla.*rv:([\d+.]+)/i.exec(navigator.userAgent);
            if (mozilla) {
                this._browserInformation.mozilla = true;
                this._browserInformation.version = mozilla[1];
                return;
            }
        }
    }
}

export function isFirefox(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();

    return BrowserInformation.getInstance().getBrowserInformation().mozilla && userAgent.indexOf("trident") === -1;
}

export function isChrome(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().chrome;
}

export function isSafari(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().safari;
}

export function isMozilla(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().mozilla;
}

/**
 * Returns true if browser is Internet Explorer 10 or earlier.
 */
export function isMsie(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().msie;
}

/**
 *  Returns true if the browser is Internet Explorer
 */
export function isIE(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (BrowserInformation.getInstance().getBrowserInformation().msie) {
        return true;
    }
    else if (userAgent.indexOf("trident") !== -1) {
        //using trident as it is used as the string  in user agent name for IE11
        return true;
    }
    return false;
}

export function isEdge(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().edge;
}

export function getVersion(): string {
    return BrowserInformation.getInstance().getBrowserInformation().version;
}

export function isIEVersion(version: number): boolean {
    if (isIE()) {
        let browserVersion: number = 0;
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (BrowserInformation.getInstance().getBrowserInformation().msie) {
            browserVersion = Number(BrowserInformation.getInstance().getBrowserInformation().version);
        }
        else if (userAgent.indexOf("trident") !== -1) {
            //using trident as it is used as the string  in user agent name for IE11
            browserVersion = 11;
        }
        return version === browserVersion;
    }
    return false;
}

export function isLessThanOrEqualToIE9(): boolean {
    if (isIE()) {
        const browserVersion: number = Number(BrowserInformation.getInstance().getBrowserInformation().version);
        return (browserVersion > 0) && (browserVersion <= 9);
    }
    return false;
}

export function isLessThanOrEqualToIE8(): boolean {
    if (isIE()) {
        const browserVersion: number = Number(BrowserInformation.getInstance().getBrowserInformation().version);
        return (browserVersion > 0) && (browserVersion <= 8);
    }
    return false;
}

export function isMacintosh(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().isMacintosh;
}

export function isWindows(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().isWindows;
}

export function isIOS(): boolean {
    return BrowserInformation.getInstance().getBrowserInformation().iOS;
}

